import { cn } from '@utazzo/ui';

import { DEPARTMENT_META } from '../item-kind';

import type { OpsDepartment } from '@utazzo/shared';

/** Small desk chip: "Flight", "DMC / Hotel", "Visa" - which desk's share of a lead a case is. */
export const DepartmentChip = ({
  department,
  className,
}: {
  department: OpsDepartment;
  className?: string;
}): React.JSX.Element => {
  const meta = DEPARTMENT_META[department];
  const Icon = meta.icon;
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-md px-1.5 py-0.5 text-[11px] font-medium ring-1',
        meta.tone,
        className,
      )}
      title={`${meta.label} desk`}
    >
      <Icon className="h-3 w-3" />
      {meta.label}
    </span>
  );
};
